// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-8d6e8afa]:export{siteFontFamily:system-ui,sans-serif,math,ui-rounded,ui-monospce}.ui-global-menu[data-v-8d6e8afa]{cursor:pointer;height:52px;line-height:52px;padding-left:20px;vertical-align:middle}.ui-global-menu .iconfont[data-v-8d6e8afa]{display:inline-block;vertical-align:top}.ui-global-menu label[data-v-8d6e8afa]{margin-left:9px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
